import { apiClient } from "services/api-client"

export const getAssets = async (tenant) => {
    return await apiClient.get(`/mapping/asset?companyKey=${tenant}`)
}
export const getAssetsPaged = async (tenant, page, perPage) => {
    return await apiClient.get(`/mapping/asset/paged?companyKey=${tenant}&page=${page}&perPage=${perPage}`)
}

export const getAssetsShort = async (tenant) => {
    return await apiClient.get(`/mapping/asset/short-data?companyKey=${tenant}`)
}

export const getAssetsShortPaged = async (tenant, page, perPage, queryContent) => {
    return await apiClient.get(`/mapping/asset/short-data-paged?companyKey=${tenant}&page=${page}&perPage=${perPage}${queryContent}`)
}

export const getAssetsNames = async (tenant) => {
    return await apiClient.get(`/mapping/asset/names?companyKey=${tenant}`)
}

export const getAssetById = async (id) => {
    return await apiClient.get(`/mapping/asset/${id}`)
}

export const getAssetBoundsById = async (id) => {
    return await apiClient.get(`/mapping/asset/${id}/bounds`)
}

export const addAsset = async (asset) => {
    return await apiClient.post('/mapping/asset', asset)
}

export const editAsset = async (id, asset) => {
    return await apiClient.put(`/mapping/asset/${id}`, asset)
}

export const deleteAsset = async (id) => {
    return await apiClient.delete(`/mapping/asset/${id}`)
}

export const archiveAsset = async (id) => {
    return await apiClient.post(`/mapping/asset/archive/${id}`)
}

export const unarchiveAsset = async (id) => {
    return await apiClient.post(`/mapping/asset/unarchive/${id}`)
}